export default __webpack_public_path__ + "static/media/cow.6fe687cc.obj";